import * as React from 'react';
import { isNil } from 'lodash';

import { Typography } from '../material-ui/Typography';
import { Weights } from '../../reducers/systemOfMeasurement';
import { useStyles } from './useStyles';

export const WeightUnits = React.memo(({ weightUnits }) => {
    const classes = useStyles();

    if (isNil(weightUnits)) {
        return null;
    }

    return <Typography className={classes.text}>{Weights[weightUnits]}</Typography>;
});

WeightUnits.displayName = 'WeightUnits';
